<app-dashboard-container
	(doExport)="this.doExport(filterExpressions(),permanentFilterExpressions,$event)"
	[factTable]="factTable"
	class="dashboard-cijfers"
>
	<app-filter-panel
		(filterExpressionsChange)="filterExpressions.set($event)"
		[allFilters]="allFilters()"
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[permanentFilterExpressions]="permanentFilterExpressions"
		endpoint="/cijfers"
	></app-filter-panel>
	<app-filter-bar></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov']"></app-legenda>
		</app-dashboard-header>
		@switch (variant()) {
			@case (DashboardVariant.ACTUEEL) {
				<app-card-list
					[config]="this"
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groups"
					[sortHeaders]="actueelSortHeaders"
					[template]="actueelCardTemplate"
					data-exportable
				>
					<ng-template #actueelCardTemplate let-row="row" let-context="context" let-group="group">
						<app-card-cell-header
							[abb_medewerker]="group['cf_fks_mw.mw_abb_medewerker']"
							[title]="getGroupTitle(group)"
							[subtitle]="group['cf_fks_mw.mw_abb_medewerker']"
						></app-card-cell-header>
						<app-hbar-partition [data]="generateHbarPartition(row, context)" [axis]="false"></app-hbar-partition>
						<app-card-cell-footer [measures]="generateMeasures(row)"></app-card-cell-footer>
					</ng-template>
				</app-card-list>
			}
			@case (DashboardVariant.HISTORIE) {
				<app-card-list
					[config]="this"
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groups"
					[subgroups]="subGroups"
					[sortHeaders]="historieSortHeaders"
					[template]="historieCardTemplate"
					data-exportable
				>
					<ng-template #historieCardTemplate let-row="row" let-context="context" let-group="group">
						<app-card-cell-header
							[abb_medewerker]="group['cf_fks_mw.mw_abb_medewerker']"
							[title]="getGroupTitle(group)"
							[subtitle]="group['cf_fks_mw.mw_abb_medewerker']"
						></app-card-cell-header>
						<app-vbar-series [yAxis]="yAxis" [partitions]="generateVbarPartitions(row, context)"></app-vbar-series>
					</ng-template>
				</app-card-list>
			}
		}
	</section>
</app-dashboard-container>
